import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BannerModel } from '../shared/models/banner-model';
import { BannerTargetEnum } from '../shared/models/banner-target-enum';
import { BannerTypeEnum } from '../shared/models/banner-type-enum';
import { SettingsService } from '../shared/services/settings.service';

@Component({
  selector: 'app-ads-edit-tab',
  templateUrl: './ads-edit-tab.component.html',
  styleUrls: ['./ads-edit-tab.component.less'],
  standalone: false,
})
export class AdsEditTabComponent implements OnInit {
  private sub: Subscription;
  private sub2: Subscription;

  public bannerPositionId: number;
  public bannerPositionName: string;
  public targetId: number;
  public edit: boolean;

  public type: any;
  public bannerModel: BannerModel;
  public isImage: Boolean;
  public tabIndex: number;
  public target: any;

  constructor(
    private route: ActivatedRoute,
    private settingsService: SettingsService
  ) {
    this.bannerModel = new BannerModel();
    this.type = BannerTypeEnum;
    this.target = BannerTargetEnum;
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe((p) => {
      let bannerId = +p['bannerId'];
      this.bannerPositionId = +p['positionId'];

      this.getBannerPositionName();

      if (bannerId) {
        this.edit = true;
        this.initData(bannerId);
      }
    });

    this.sub2 = this.route.queryParams.subscribe((params) => {
      this.targetId = +params['device'];
    });
  }

  private getBannerPositionName() {
    this.settingsService
      .getBannerPosition(this.bannerPositionId)
      .subscribe((t) => {
        this.bannerPositionName = t.headBannerPosition.name + ' ' + t.name;
      });
  }

  private initData(bannerId: number) {
    this.settingsService.getBanner(bannerId, this.bannerPositionId).subscribe((t) => {
      this.bannerModel.bannerId = t.bannerId;
      this.bannerModel.positionId = this.bannerPositionId;

      this.bannerModel.targetId = t.targetId;
      this.bannerModel.name = t.name;
      this.bannerModel.link = t.link;
      this.bannerModel.code = t.code;
      this.bannerModel.imageFileName = t.imageFileName;
      this.bannerModel.deactivationDate =
        t.deactivationDate != null
          ? new Date(t.deactivationDate)
          : t.deactivationDate;

      if (t.typeId == this.type.Image) {
        this.isImage = true;
      }
      this.bannerModel.typeId = t.typeId;
      this.targetId = t.targetId;
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.sub2.unsubscribe();
  }
}
